import ProductService from '@/api/services/ProductService';

export const namespaced = true;

export const state = {
  loading: false,
  glowTagProducts: {},
  connectorProducts: {},
};

export const mutations = {
  SET_GLOW_TAG_PRODUCT(state, glowTagProducts) {
    state.glowTagProducts = glowTagProducts;
  },
  SET_CONNECTOR_PRODUCT(state, connectorProducts) {
    state.connectorProducts = connectorProducts;
  },
  LOADING(state, loading) {
    state.loading = loading;
  },
};

export const actions = {
  fetchGlowTagProduct({ commit, dispatch }) {
    commit('LOADING', true);
    ProductService.getProductByIDs([3284, 3290, 3291])
      .then((response) => {
        commit('SET_GLOW_TAG_PRODUCT', response);
        commit('LOADING', false);
      })
      .catch((error) => {
        commit('LOADING', false);
        commit('SET_GLOW_TAG_PRODUCT', {});
        error.location = 'fetchGlowTagProduct';
        console.log(error);
        const notification = {
          type: 'warning',
          message: 'There was an error loading glow tag products.',
        };
        dispatch('notification/add', notification, { root: true });
        return Promise.reject(error);
      });
  },
  fetchConnectorProducts({ commit, dispatch }, { cityId }) {
    commit('LOADING', true);
    ProductService.getProductsByTypes(['CONNECTOR'], cityId)
      .then((response) => {
        commit('SET_CONNECTOR_PRODUCT', response?.['Connector_Products']);
        commit('LOADING', false);
      })
      .catch((error) => {
        commit('LOADING', false);
        commit('SET_CONNECTOR_PRODUCT', {});
        error.location = 'fetchConnectorProducts';
        console.log(error);
        const notification = {
          type: 'warning',
          message: 'There was an error loading connector products.',
        };
        dispatch('notification/add', notification, { root: true });
        return Promise.reject(error);
      });
  },
};
